module.exports = __webpack_public_path__ + "img/features-bitmap-fonts.258cc651.png";